"use client";
import React, { useContext } from "react";
import dynamic from "next/dynamic";
import { useRouter } from "next/navigation";
import { Button as ButtonLib } from "@npm_leadtech/qr-ui-components";
import { Banner } from "@/components/Banner";
import { Typography } from "@/components/Typography";
import { BannerWrapperSize } from "@/components/Banner/types";
import { featuredProps } from "@/data/types/home";
import { AmplitudeContext } from "@/contexts/AmplitudeContext/AmplitudeContext";
import { paths } from "@/utils/paths";

import "./styles.scss";

// Fix Warning: Prop 'className' did not match. Import component by turning off ssr
const Featured = dynamic(() => import("@/components/Featured").then((mod) => mod.Featured), {
  ssr: false,
});

export const ThreeStepsModule = ({
  data,
  wrapperSize,
}: {
  data: featuredProps;
  wrapperSize: BannerWrapperSize;
}) => {
  const router = useRouter();
  const { List, Title, ctaLabel, data_qa, backgroundColor, customClass } = data;
  const { setSource } = useContext(AmplitudeContext);

  const handleStepsClick = () => {
    setSource("cta_steps");
    router.push(paths.qrEditor());
  };

  return (
    <Banner
      big
      light
      customBgColor={backgroundColor}
      wrapperSize={wrapperSize}>
      <Typography
        Tag={"h2"}
        spacing={8}>
        {Title}
      </Typography>
      <Featured
        items={List}
        customClass={customClass}
      />
      <div className="buttonWrapper cta-steps-banner-btn">
        <ButtonLib
          dataQA={data_qa}
          onClick={handleStepsClick}
          label={ctaLabel}
          variant="secondary"
        />
      </div>
    </Banner>
  );
};
